/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

import { useRouter } from 'next/router';
import { NextPage } from 'next';

const Index: NextPage = () => {
  const router = useRouter();
  useEffect(() => {
    router.push('/prompts');
  }, []);

  return <></>;
};

export default Index;
